import { XCircle } from "lucide-react";

/** Shown when the user cancels Stripe Checkout. */
export default function PaymentCancel() {
    return (
        <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
            <XCircle className="h-12 w-12 text-[#a0a0a0] mx-auto mb-4" />
            <div className="font-display text-4xl tracking-wide">Checkout cancelled</div>
            <p className="text-sm text-[#a0a0a0] mt-2">No charge was made. You can upgrade anytime.</p>
            <a href="/account" data-testid="payment-cancel-account" className="mt-6 inline-block bg-[#ff4500] hover:bg-[#ff5722] text-white px-6 py-3 uppercase tracking-[0.2em] text-xs font-semibold">Back to account</a>
        </div>
    );
}
